/** Display the server's applied growth values; never recalculate combat stats in the browser. */
import { S } from '../core/state.js';
const number = value => Number(value).toLocaleString('ko-KR', { maximumFractionDigits: 6 });
const valid = value => typeof value === 'number' && Number.isFinite(value) && value >= 0;

export function levelGrowthRules(growth = S.you?.levelGrowth) {
  if (!growth || !['levelHpPer', 'levelDefBefore', 'levelDefAfter', 'levelDefKnee'].every(key => valid(growth[key])))
    return '레벨이 오르면 최대 체력과 방어력이 함께 오른다. 현재 성장 수치는 접속 후 확인할 수 있다.';
  return `레벨 1 이후 레벨업마다 최대 체력 보너스 ${number(growth.levelHpPer * 100)}%p를 누적한다. `
    + `방어력은 레벨 ${number(growth.levelDefKnee)}까지 레벨업마다 +${number(growth.levelDefBefore)}, 이후 +${number(growth.levelDefAfter)}씩 얻는다.`;
}

export function levelGrowthSummary(growth, details = false) {
  if (!growth || !valid(growth.hpBonusPct) || !valid(growth.defBonus)) return '';
  return '<div class="item statitem level-growth"><span class="nm">레벨 성장 보너스'
    + `<span class="qt">최대 체력 <b>+${number(growth.hpBonusPct)}%</b> · 방어력 <b>+${number(growth.defBonus)}</b></span>`
    + (details ? `<span class="qt">${levelGrowthRules(growth)} 플레이어와 원주민에게 같은 규칙을 적용한다.</span>` : '')
    + '</span></div>';
}
